<template>
  <div class="paperPreview" v-loading="loading">
    <div class="paperPreviewMidle">
      <div class="header">
        <p>{{name}}（{{total}}）</p>
      </div>
      <div class="tabs" @click.stop="clickStop">
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane
            v-for="(item,index) in questionTabNames"
            :key="index"
            :label="item.sectionName"
            :name="'page'+index"
          ></el-tab-pane>
        </el-tabs>
      </div>
      <div class="paperPreviewSection" @scroll="handleScroll" ref="content">
        <div class="test">
          <ul>
            <li
              :id="['page'+index]"
              v-for="(item,index) in questionContent"
              :key="index"
              class="test-item"
            >
              <div class="title">
                {{chnNumCharStr(index)}} 、{{item.sectionAlias ||item.sectionName}}
                <span>（{{item.sectionPrompt}}）</span>
              </div>
              <ul>
                <li class="test_small" v-for="(v,i) in item.questions" :key="i">
                  <!--非组合题-->
                  <div v-if="v.internalTypeId !== 6">
                    <span class="text_index1" v-if="v.internalTypeId === 9">{{v.questionNum}}.</span>
                    <div class="text_box">
                      <span class="text_index" v-if="v.internalTypeId !== 9">{{v.questionNum}}.</span>
                      <div class="test_small_title1 ql-editor" v-if="v.internalTypeId === 9">
                        <p class="text" v-html="v.questionContent"></p>
                      </div>
                      <div
                        class="test_small_title ql-editor"
                        v-html="v.questionContent"
                        v-if="v.internalTypeId !== 9"
                      ></div>
                    </div>
                    <!--单选题-->
                    <ul class="answer" v-if="v.internalTypeId === 1">
                      <el-radio-group v-model="v.questionAnswer">
                        <li v-for="(k,j) in v.items" :key="j">
                          <el-radio
                            :label="k.itemKey"
                            :disabled="v.questionAnswer == k.itemKey? false:true"
                          >
                            <span>{{k.itemKey}}：</span>
                            <div class="radio_item" v-html="k.itemValue"></div>
                          </el-radio>
                        </li>
                      </el-radio-group>
                    </ul>
                    <!--多选题-->
                    <ul class="answer" v-if="v.internalTypeId === 2">
                      <el-checkbox-group v-model="v.questionAnswer.split(',')">
                        <li v-for="(k,j) in v.items" :key="j">
                          <el-checkbox
                            :disabled="v.questionAnswer.includes(k.itemKey)? false:true"
                            :label="k.itemKey"
                          >
                            <span>{{k.itemKey}}：</span>
                            <p v-html="k.itemValue"></p>
                          </el-checkbox>
                        </li>
                      </el-checkbox-group>
                    </ul>
                    <!--判断题-->
                    <ul class="answer" v-if="v.internalTypeId === 3">
                      <li>
                        <el-radio
                          v-model="v.questionAnswer"
                          label="正确"
                          :disabled="v.questionAnswer=='错误'?true:false"
                        >{{ answerExchange(v.englishOption, '正确') }}</el-radio>
                      </li>
                      <li>
                        <el-radio
                          v-model="v.questionAnswer"
                          label="错误"
                          :disabled="v.questionAnswer=='正确'?true:false"
                        >{{ answerExchange(v.englishOption, '错误') }}</el-radio>
                      </li>
                    </ul>
                    <p
                      v-if="v.internalTypeId === 1 || v.internalTypeId === 2 || v.internalTypeId === 3"
                    >
                      正确答案：
                      <span>{{ answerExchange(v.englishOption, v.questionAnswer) }}</span>
                    </p>
                    <div v-if="v.internalTypeId === 4">
                      正确答案：
                      <p v-html="v.questionAnswer"></p>
                    </div>
                    <div
                      class="analysis"
                      v-if="v.flag && v.internalTypeId !== 9"
                      @click.stop="openAnalysis(v)"
                    >
                      打开解析
                      <img :src="imgSrcDown" />
                    </div>
                    <div
                      class="analysis"
                      v-if="!v.flag && v.internalTypeId !== 9"
                      @click.stop="openAnalysis(v)"
                    >
                      收起解析
                      <img :src="imgSrcUp" />
                    </div>
                    <span
                      v-if="!v.flag && v.internalTypeId !== 9"
                      class="analysis_cont"
                      v-html="v.questionAnalysis?v.questionAnalysis:'暂无解析'"
                    ></span>
                    <span
                      class="answerShow"
                      v-if="v.flag && v.internalTypeId === 9"
                      @click.stop="openAnalysis(v)"
                    >
                      打开答案
                      <img :src="imgSrcDown" />
                    </span>
                    <span
                      class="answerHide"
                      v-if="!v.flag && v.internalTypeId === 9"
                      @click.stop="openAnalysis(v)"
                    >
                      收起答案
                      <img :src="imgSrcUp" />
                    </span>
                    <span
                      v-if="v.internalTypeId === 9 && userType !== 0 && optObject.classId"
                      class="intoSystem"
                      @click.stop="entrySys(v)"
                    >
                      进入实操系统
                      <img src="../../../static/images/study/icon/right.png" />
                    </span>
                    <div class="commentCont" v-if="!v.flag && v.internalTypeId == 9">
                      <div class="comment1"></div>
                      <div class="comment2">
                        <my-component
                          isShow
                          :optObject="optObject"
                          :refresh="refresh"
                          :myId="v.questionId"
                          :type="type"
                          :preview="true"
                          :companyCode="companyCode"
                        ></my-component>
                      </div>
                      <div class="comment3"></div>
                    </div>
                  </div>
                  <!--组合题-->
                  <div class="line" v-if="v.internalTypeId === 6 && item.questions.length > 1"></div>
                  <div class="combination" v-if="v.internalTypeId === 6">
                    <div class="test_small_title1 ql-editor" v-if="v.internalTypeId === 9">
                      <p class="text" v-html="v.questionContent"></p>
                    </div>
                    <p
                      class="question_index"
                      v-if="v.questionNum == v.questionNum + v.childQuestions.length -1"
                    >阅读以下内容，回答第{{v.questionNum}}题</p>
                    <p
                      class="question_index"
                      v-else
                    >阅读以下内容，回答第{{v.questionNum}}-{{v.questionNum + v.childQuestions.length -1}}题</p>
                    <div
                      class="test_small_title ql-editor"
                      v-html="v.questionContent"
                      v-if="v.internalTypeId !== 9"
                    ></div>
                    <div class="groupQuestion" v-for="(single,m) in v.childQuestions" :key="m">
                      <div class="question_content">
                        <span>{{ single.questionNum }}.</span>
                        <p class="text ql-editor" v-html="single.questionContent"></p>
                      </div>
                      <!--单选题-->
                      <ul class="answer" v-if="single.internalTypeId === 1">
                        <el-radio-group v-model="single.questionAnswer">
                          <li v-for="(k,j) in single.items" :key="j">
                            <el-radio
                              :label="k.itemKey"
                              :disabled="single.questionAnswer == k.itemKey? false:true"
                            >
                              <span>{{k.itemKey}}：</span>
                              <div class="radio_item" v-html="k.itemValue"></div>
                            </el-radio>
                          </li>
                        </el-radio-group>
                      </ul>
                      <!--多选题-->
                      <ul class="answer" v-if="single.internalTypeId === 2">
                        <el-checkbox-group v-model="single.questionAnswer.split(',')">
                          <li v-for="(k,j) in single.items" :key="j">
                            <el-checkbox
                              :disabled="single.questionAnswer.includes(k.itemKey)? false:true"
                              :label="k.itemKey"
                            >
                              <span>{{k.itemKey}}：</span>
                              <p v-html="k.itemValue"></p>
                            </el-checkbox>
                          </li>
                        </el-checkbox-group>
                      </ul>
                      <!--判断题-->
                      <ul class="answer" v-if="single.internalTypeId === 3">
                        <li>
                          <el-radio
                            v-model="single.questionAnswer"
                            label="正确"
                            :disabled="single.questionAnswer=='错误'?true:false"
                          >{{ answerExchange(single.englishOption, '正确') }}</el-radio>
                        </li>
                        <li>
                          <el-radio
                            v-model="single.questionAnswer"
                            label="错误"
                            :disabled="single.questionAnswer=='正确'?true:false"
                          >{{ answerExchange(single.englishOption, '错误') }}</el-radio>
                        </li>
                      </ul>
                      <p
                        v-if="single.internalTypeId === 1 || single.internalTypeId === 2 || single.internalTypeId === 3"
                      >
                        正确答案：
                        <span>{{ answerExchange(single.englishOption, single.questionAnswer) }}</span>
                      </p>
                      <div v-if="single.internalTypeId === 4">
                        正确答案：
                        <p v-html="single.questionAnswer"></p>
                      </div>
                      <div
                        class="analysis"
                        v-if="single.flag && single.internalTypeId !== 9"
                        @click.stop="openAnalysis(single)"
                      >
                        打开解析
                        <img :src="imgSrcDown" />
                      </div>
                      <div
                        class="analysis"
                        v-if="!single.flag && single.internalTypeId !== 9"
                        @click.stop="openAnalysis(single)"
                      >
                        收起解析
                        <img :src="imgSrcUp" />
                      </div>
                      <span
                        v-if="!single.flag && single.internalTypeId !== 9"
                        class="analysis_cont"
                        v-html="single.questionAnalysis?single.questionAnalysis:'暂无解析'"
                      ></span>
                      <span
                        class="answerShow"
                        v-if="single.flag && single.internalTypeId === 9"
                        @click.stop="openAnalysis(single)"
                      >
                        打开答案
                        <img :src="imgSrcDown" />
                      </span>
                      <span
                        class="answerHide"
                        v-if="!single.flag && single.internalTypeId === 9"
                        @click.stop="openAnalysis(single)"
                      >
                        收起答案
                        <img :src="imgSrcUp" />
                      </span>
                      <div class="commentCont" v-if="!single.flag && single.internalTypeId == 9">
                        <div class="comment1"></div>
                        <div class="comment2">
                          <my-component
                            isShow
                            :optObject="optObject"
                            :refresh="refresh"
                            :myId="single.questionId"
                            :type="type"
                            :preview="true"
                            :companyCode="companyCode"
                          ></my-component>
                        </div>
                        <div class="comment3"></div>
                      </div>
                    </div>
                  </div>
                  <div class="line" v-if="v.internalTypeId === 6 && item.questions.length > 1"></div>
                  <div style="clear: both"></div>
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import crypto from "crypto";
import * as api from "../../api/testApi";
import myComponent from "../../components/myComponent";
export default {
  name: "paperPreview",
  props: {
    optObject: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      name: "",
      activeName: "page0",
      imgSrcDown: "../../../static/images/study/icon/down.png",
      imgSrcUp: "../../../static/images/study/icon/up.png",
      questionTabNames: [],
      questionContent: [],
      loading: true,
      chnNumChar: ["一", "二", "三", "四", "五", "六", "七", "八", "九"],
      userType: sessionStorage.getItem("userType"),
      total: "",
      refresh: false, //刷新数据
      iframeUrl: "",
      type: "",
      productFlag: sessionStorage.getItem("productFlag"),
      companyCode: "",
      template: {},
    };
  },
  components: {
    myComponent,
  },
  watch: {
    optObject: {
      handler() {
        this.questionContent = [];
        this.getTehDate();
        if (this.productFlag == 3) {
          this.type = 3;
        } else {
          this.type = 2;
        }
      },
      immediate: true,
      deep: true,
    },
  },
  created() {},
  methods: {
    handleClick(tab, event) {
      var PageId = document.querySelector("#page" + tab.index);
      PageId.scrollIntoView();
    },
    clickStop(){},
    // 打开解析(收起解析)
    openAnalysis(param) {
      this.$set(param, "flag", !param.flag);
      this.getparams(param.questionId);
    },
    //获取测验预览数据
    getTehDate() {
      let paperId = this.optObject.paperId;
      let index = 1;
      let request;
      if (this.optObject.classId) {
        let param = {
          id: paperId,
          courseId: this.optObjectid.courseId,
          classId: this.optObject.classId,
        };
        request = api.getTeacherPreview(param);
      } else {
        request = api.testPaper(paperId);
      }
      request
        .then((res) => {
          if (res.code == 0) {
            this.name = res.data.paperName;
            this.total = res.data.totalScore + "分";
            this.questionTabNames =
              res.data.testPaperPartsList[0].testPaperSectionsList;
            let testPaperDates =
              res.data.testPaperPartsList[0].testPaperSectionsList;
            testPaperDates.forEach((val) => {
              let obj = {};
              obj.sectionName = val.sectionName;
              obj.sectionPrompt = val.sectionPrompt;
              obj.questions = [];
              val.testPaperQuestionsList.forEach((item) => {
                let question = {};
                question.internalTypeId = item.questionDto.internalTypeId;
                question.questionContent = item.questionDto.questionContent;
                question.items = item.questionDto.items;
                question.questionAnswer = item.questionDto.questionAnswer;
                question.englishOption = item.questionDto.englishOption;
                question.questionAnalysis = item.questionDto.questionAnalysis;
                question.flag = true;
                question.score = item.questionDto.score;
                question.questionNum = index++;
                question.questionId = item.questionDto.id;
                question.childQuestions = [];
                if (question.internalTypeId == 6) {
                  index--;
                  item.questionDto.childQuestions.forEach((m) => {
                    let childQuestionsObj = {};
                    childQuestionsObj.internalTypeId = m.internalTypeId;
                    childQuestionsObj.questionContent = m.questionContent;
                    childQuestionsObj.items = m.items;
                    childQuestionsObj.questionAnswer = m.questionAnswer;
                    childQuestionsObj.englishOption = m.englishOption;
                    childQuestionsObj.questionAnalysis = m.questionAnalysis;
                    childQuestionsObj.questionId = m.id;
                    childQuestionsObj.questionNum = index++;
                    childQuestionsObj.flag = true;
                    question.childQuestions.push(childQuestionsObj);
                  });
                }
                obj.questions.push(question);
              });
              this.questionContent.push(obj);
            });
            this.loading = false;
          } else {
            this.loading = false;
            this.$messageError(res.msg);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    //阿拉伯数字转中文
    chnNumCharStr(index) {
      return this.chnNumChar[index];
    },
    handleScroll() {
      let scrollTop = this.$refs.content.scrollTop;
      let topicLi = document.querySelectorAll(".test-item");
      topicLi.forEach((item, index) => {
        if (scrollTop >= item.offsetTop - 120) {
          this.activeName = "page" + index;
        }
      });
    },
    slJump(data, id) {
      //商旅跳转
      let that = this;
      console.log(data);
      that.template = data;
      async function getData() {
        let jumpObj = that.getJumpInfo("sl", id);
        let roleCodes = [];
        let arr = [];
        that.template.forEach((val) => {
          val.dynmaicParamReqList.forEach((item) => {
            if (item.param == "roles") {
              roleCodes.push(item.value);
            }
          });
        });
        roleCodes = roleCodes[0];
        let templateCode = "";
        let list = await that.getparams(id);
        if (list.length > 0) {
          list.forEach((v) => {
            if (v.key == "templateCode") {
              templateCode = v.value;
            }
          });
        }
        let name = Base64.encode(jumpObj.nickname);
        let host = process.env.XSL_API;
        that.zljtLogin("sl", id, roleCodes, templateCode).then((rs) => {
          if (rs.data.code == 0) {
            let slParams = `qstId=${jumpObj.qstId}&token=${rs.data.data.access_token}&nickname=${name}`;
            let src = `${host}?${slParams}`;
            that.iframeUrl = src;
            window.open(that.iframeUrl, "_blank");
          } else {
            that.$messageError(rs.data.msg);
          }
        });
      }
      getData();
    },
    setSha1(url, secretKey) {
      // 加密
      let hmac = crypto.createHmac("sha1", secretKey || "123456");
      hmac.update(url);
      return hmac.digest("hex");
    },
    /**
     *
     *根据资源ID 获取动态参数列表
     */
    getparams(questionId) {
      let list = [];
      return new Promise((resolve) => {
        api
          .getParams(questionId)
          .then((rs) => {
            console.log(rs);
            if (rs.code === "0") {
              if (rs.data.length > 0) {
                rs.data.map((item) => {
                  let obj = {
                    key: item.param,
                    value: item.value,
                  };
                  list.push(obj);
                  if (item.param == "templateCode") {
                    this.companyCode = item.value;
                  }
                });
                resolve(list);
              }
              resolve(list);
            } else {
              this.$messageError(rs.msg);
            }
          })
          .catch(function (error) {
            this.$messageError("后台接口错误！");
          });
      });
    },
    async zljtLogin(type, id, roleCodes, templateCode) {
      // 中联集团登录
      let jumpObj = this.getJumpInfo(type, id);
      // 加密参数
      let shanStr = `{clientId=${jumpObj.clientId}, encrypted=${jumpObj.encrypted}, identity=${jumpObj.identity}, item=${jumpObj.item}, qstId=${jumpObj.qstId}, roleCode=${roleCodes}, templateCode=${templateCode}, timeStamp=${jumpObj.timestamp}, token=${jumpObj.token}, userType=${jumpObj.userType}, username=${jumpObj.username}}`;
      let secretKey = this.setSha1(shanStr, "02424D4FD04A007E453DADA28E4EEE37");
      let params = {
        clientId: jumpObj.clientId,
        encrypted: jumpObj.encrypted,
        identity: jumpObj.identity,
        item: jumpObj.item,
        qstId: jumpObj.qstId,
        roleCode: roleCodes,
        sign: secretKey,
        templateCode: templateCode,
        timeStamp: jumpObj.timestamp,
        token: jumpObj.token,
        userId: jumpObj.userId,
        userType: jumpObj.userType,
        username: jumpObj.username,
      };
      let src = `${process.env.ZLJT_API}/api-oauth/v1/oauth/v2/oauth/token`;
      return axios.post(src, params).then((rs) => rs);
    },
    getJumpInfo(sys, id) {
      // 跳转所用参数集合
      let that = this;
      let productFlag = sessionStorage.getItem("productFlag"); // 产品：1、书证融通，2、单项训练，3、综合实训，4、真实任务
      let courseId = that.optObject.id;
      let classId = that.optObject.classId;
      let identity = "";
      /*
			    encrypted拼接规则: (示例: TEACH_123_999_2_200_001)
			    系统: （教学: TEACH）、（考试: EXAMS）、（大赛: MATCH）
			    123: (教学: courseId)、（考试: NONE）、（大赛: NONE）
			    999: (教学: classId)、（考试: examPlanId）、（大赛: examPlanId）
			    2: (单项: 1)、（实训: 2）
			    200: (单项: NONE)、（实训: teamId）
			    001: templateCode
			  */
      let encrypted = "";
      if (productFlag == 1 || productFlag == 2) {
        //单项
        identity = sys + "dx";
        encrypted = `TEACH_${courseId}_${classId}_1_NONE`;
      } else if (productFlag == 3) {
        //综合
        identity = sys + "zh";
        encrypted = `TEACH_${courseId}_${classId}_2_NONE`;
      }
      let obj = {
        token: localStorage.getItem("Authorization"),
        courseId: courseId, // 课程id
        classId: classId, // 班级id
        qstId: id, //试题id
        schoolId: sessionStorage.getItem("deptId"), // 机构id
        orgName: sessionStorage.getItem("deptName"), // 机构名称
        username: sessionStorage.getItem("userName"), // 账号
        userId: sessionStorage.getItem("userId"), // 用户id
        nickname: sessionStorage.getItem("loginName"), // 用户姓名
        userType: sessionStorage.getItem("userType"), // 用户类型
        mobile: sessionStorage.getItem("mobile"), // 手机号
        sex: sessionStorage.getItem("sex"), // 性别
        headImgUrl: "", // 头像
        idCard: "", // 身份证
        password: "e10adc3949ba59abbe56e057f20f883e",
        // item: ${questionDto.questionCode},
        item: "27011201-6fe9-46b4-ba7f-fe241aed2132", // questionCode
        identity: identity,
        encrypted: encrypted,
        clientId: "1349883712819109890",
        timestamp: new Date().getTime(),
      };
      return obj;
    },
    // 判断题 中英文选项
    answerExchange(english, answer) {
      return english
        ? answer == "正确"
          ? "T"
          : answer == "错误"
          ? "F"
          : ""
        : answer;
    },
  },
};
</script>

<style scoped lang="scss">
.paperPreview {
  height: 100%;
  width: 100%;
  background: #f4f4f4;
  .paperPreviewMidle {
    background: #f4f4f4;
    height: 100%;
    display: flex;
    flex-direction: column;
    .header {
      padding: 10px;
      p {
        height: 56px;
        background: #1d70e2;
        line-height: 56px;
        text-align: center;
        font-size: 18px;
        color: #fff;
        font-family: Source Han Sans CN;
      }
    }
    .tabs {
      padding: 10px;
      .el-tabs {
        background: #fafcfd;
        padding: 0 10px;
      }
      /deep/ .el-tabs__item {
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: normal;
        color: #999999;
      }
      /deep/ .el-tabs__item.is-active {
        color: #333333;
        font-weight: 600;
      }
      /deep/ .el-tabs__active-bar {
        height: 1px;
        background-color: #333333;
      }
    }
    .paperPreviewSection {
      padding: 10px;
      flex: 1;
      overflow-y: auto;
      .test {
        padding: 0 108px;
        background: #fafcfd;
        padding-top: 15px;
        padding-bottom: 20px;
        .test-item {
          margin-bottom: 40px;
          .title {
            color: #333333;
            font-size: 16px;
            font-weight: 600;
            margin-bottom: 16px;
            span {
              font-size: 12px;
              font-weight: 400;
            }
          }
          .test_small {
            justify-content: space-around;
            margin-bottom: 40px;
            .text_box {
              display: flex;
              justify-content: left;
            }
            /deep/ p.ql-align-justify {
              margin-top: -5px;
            }
            .text_index {
              font-size: 14px;
              color: #333333;
              font-weight: 600;
              margin-right: 10px;
            }
            .text_index1 {
              float: left;
              font-size: 14px;
              color: #333333;
              font-weight: 600;
              line-height: 26px;
              margin-right: 10px;
            }
            .test_small_title {
              font-size: 14px;
              margin-bottom: 16px;
              display: inline-block;
              /deep/ p {
                display: inline-block;
                img {
                  width: 100%;
                }
                span {
                  line-height: 24px;
                  img {
                    width: 100%;
                  }
                }
              }
            }
            .test_small_title1 {
              font-size: 14px;
              margin-bottom: 16px;
              p.text {
                width: 100%;
                line-height: 26px;
                /deep/ p {
                  img {
                    display: block;
                    max-width: 100%;
                  }
                }
                span {
                  line-height: 24px;
                }
              }
            }
            .answer_radio {
              display: inline-block;
              span {
                display: inline-block;
                padding: 0 30px;
                color: #5397f7;
                font-size: 14px;
              }
            }
            .panduan {
              line-height: 24px;
            }
            .answer {
              margin-left: 34px;
              margin-top: 10px;
              .el-radio-group {
                width: 100%;
              }
              li {
                margin-bottom: 16px;
                width: 100%;
                /deep/ .el-radio__input.is-disabled {
                  .el-radio__inner {
                    cursor: pointer;
                  }
                }
                /deep/ .el-radio__input.is-disabled + span.el-radio__label {
                  cursor: pointer;
                  color: #606266;
                }
                /deep/ .el-radio__label {
                  .radio_item {
                    display: inline-flex;
                    width: 100%;
                  }
                  p {
                    display: inline-block;
                    white-space: pre-wrap;
                    word-wrap: break-word;
                    box-sizing: border-box;
                    width: 96%;
                    img {
                      width: 100%;
                    }
                  }
                }
                /deep/ .el-checkbox__label {
                  p {
                    display: inline-block;
                  }
                }
                /deep/ .el-radio__input.is-disabled {
                  .el-radio__inner {
                    background-color: #fff;
                  }
                }
                /deep/ .el-checkbox__input.is-disabled {
                  .el-checkbox__inner {
                    background-color: #fff;
                  }
                }
                /deep/
                  .el-checkbox__input.is-disabled
                  + span.el-checkbox__label {
                  cursor: pointer;
                  color: #606266;
                }
                .el-radio {
                  width: 100%;
                }
              }
            }
            p {
              font-size: 14px;
              margin-bottom: 12px;
              span {
                color: #5397f7;
              }
            }
            .analysis {
              color: #5397f7;
              font-size: 14px;
              cursor: pointer;
              float: left;
              img {
                display: inline-block;
                width: 10px;
                height: 10px;
                margin-left: 4px;
              }
            }
            .analysis_cont {
              float: left;
              width: calc(100% - 105px);
              color: #333333;
              font-size: 14px;
              line-height: 24px;
              margin-bottom: 32px;
              margin-left: 24px;
              margin-top: -4px;
            }
            .answerShow,
            .intoSystem,
            .answerHide {
              color: #5397f7;
              font-size: 14px;
              cursor: pointer;
              img {
                display: inline-block;
                width: 10px;
                height: 10px;
                margin-left: 4px;
              }
            }
            .intoSystem {
              margin-left: 40px;
            }
            .commentCont {
              position: relative;
              .comment1 {
                width: 0px;
                height: 0px;
                border: 8px transparent solid;
                border-bottom-color: #f4f4f4;
                position: absolute;
                top: -15px;
                left: 41px;
              }
              .comment2 {
                background: #f4f4f4;
                /*min-height: 105px;*/
                /*max-height: 396px;*/
                height: 396px;
                border-radius: 4px;
                margin-top: 10px;
                padding: 16px;
                overflow: auto;
              }
              .comment3 {
                width: 0px;
                height: 0px;
                border: 9px transparent solid;
                border-bottom-color: rgba(244, 244, 244, 1);
                position: absolute;
                top: -15px;
                left: 40px;
              }
            }
            .combination {
              padding-top: 15px;
              padding-bottom: 25px;
              .groupQuestion {
                clear: both;
                margin-bottom: 10px;
                .question_content {
                  max-width: 100%;
                  span {
                    float: left;
                    margin-right: 10px;
                    line-height: 21px;
                    font-weight: 600;
                  }
                  p.text {
                    /deep/ p {
                      line-height: 24px;
                      width: 97%;
                      word-break: break-word;
                      img {
                        display: block;
                        max-width: 100%;
                      }
                    }
                  }
                }
              }
              .test_small_title {
                /deep/ p {
                  line-height: 24px;
                }
              }
              .analysis {
                margin-bottom: 15px;
              }
              .question_index {
                display: block;
                font-weight: 600;
                font-size: 14px;
              }
            }
            .line {
              height: 0px;
              border: 1px solid rgba(83, 151, 247, 1);
            }
          }
        }
      }
    }
  }
}
.answer_box {
  display: flex;
  justify-content: left;
}
</style>



// WEBPACK FOOTER //
// src/views/component/paperPreview.vue